import {TFunction} from 'react-i18next';

const GEN_INFO = 'pages.documents.invoices.create.documents';

type IsFieldRequired = (name: string) => boolean;

const getRequiredFlag = (isFieldRequired?: IsFieldRequired) => (name: string, fallback = false) =>
    isFieldRequired ? isFieldRequired(name) : fallback;

export const formData = (
    t: TFunction<'translation'>,
    allowToEdit: boolean,
    isFieldRequired?: IsFieldRequired,
) => ({
    general: [
        {
            type: 'date',
            label: t(`${GEN_INFO}.inputs.from`),
            placeholder: t(`${GEN_INFO}.placeholders.from`),
            name: 'periodFrom',
            required: getRequiredFlag(isFieldRequired)('periodFrom'),
            disabled: !allowToEdit,
        },
        {
            type: 'date',
            label: t(`${GEN_INFO}.inputs.due`),
            placeholder: t(`${GEN_INFO}.placeholders.due`),
            name: 'periodTo',
            required: getRequiredFlag(isFieldRequired)('periodTo'),
            disabled: !allowToEdit,
        },
        {
            type: 'date',
            label: t(`${GEN_INFO}.inputs.pointDate`),
            placeholder: t(`${GEN_INFO}.placeholders.pointDate`),
            name: 'taxPointDate',
            required: getRequiredFlag(isFieldRequired)('taxPointDate'),
            disabled: !allowToEdit,
        },
    ],
    generalSecondHalf: [
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.buyerReference`),
            placeholder: t(`${GEN_INFO}.placeholders.buyerReference`),
            name: 'buyerReference',
            required: getRequiredFlag(isFieldRequired)('buyerReference'),
            disabled: !allowToEdit,
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.purchaseOrderReference`),
            placeholder: t(`${GEN_INFO}.placeholders.purchaseOrderReference`),
            name: 'purchaseOrderReference',
            required: getRequiredFlag(isFieldRequired)('purchaseOrderReference'),
            disabled: !allowToEdit,
        },
    ],
    additional: [
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.Contract`),
            placeholder: t(`${GEN_INFO}.placeholders.Contract`),
            name: 'contractDocumentReference',
            required: getRequiredFlag(isFieldRequired)('contractDocumentReference'),
            disabled: !allowToEdit,
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.salesOrderReference`),
            placeholder: t(`${GEN_INFO}.placeholders.salesOrderReference`),
            name: 'salesOrderReference',
            required: getRequiredFlag(isFieldRequired)('salesOrderReference'),
            disabled: !allowToEdit,
        },
    ],
});
